<template>
	<AppTooltip noArrow top text="Type / or click for more">
		<IconButton tabindex="-1" small class="flex-centerize" :class="{ 'focus-animation': showFocusAnimation }" @mousedown="onClick">
			<SIcon class="plus-icon" name="plus-insert-data" :width="10" />
		</IconButton>
	</AppTooltip>
</template>

<script>
import AppTooltip from '@/components/common/AppTooltip';
export default {
	name: 'OpenMenuButton',
	components: { AppTooltip },
	methods: {
		onClick() {
			this.$emit('open');
		},
	},
	mounted() {
		setTimeout(() => {
			this.showFocusAnimation = false;
		}, 500);
	},
	data() {
		return {
			showFocusAnimation: true,
		};
	},
};
</script>
<style scoped lang="scss">
.focus-animation {
	border: 2px solid var(--primary-color) !important;
}
</style>
